import { SEARCH_KEYWORD_UPDATE_SUCCESS } from "constants/actionTypes";

const initialState = {
  keyword: '',
};

export function getSearchValues(state = initialState, action: any) {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_KEYWORD_UPDATE_SUCCESS:
      return {
        ...state,
        keyword: payload.keyword,
        pagination: payload.pagination,
      };

    default:
      return state;
  }
}
